import React from 'react'

import {FieldEditableValueNotEmptyProps} from "../../../../proto/components/editable/value-not-empty"
import ControlButtonStandard from "../../../../../gd-components/buttons/control-button/control-button-standard";
import {ControlButtonSize} from "../../../../../gd-components/buttons/control-button/@types";

type Props = {
    params: any // some special parameters
} & FieldEditableValueNotEmptyProps

// const debug = "FieldDropdown_ControlViewEmpty"
const debug = false

export default function FieldDropdown_ControlViewEmpty(props: Props) {

    debug && console.log(debug, 'render', props.field.placeholder, props)

    const labelClass = props.params?.labelClassName || "label txt-truncate ui5-txt-not-important-small"
    const arrowClass = props.params?.arrowClassName || "fs-8 not-important i5-big-angle-down flex-no-shrink m-t-3 m-l-10"

    const hasHPad = props.className?.includes('p-h')
    const classes = Classes(props.className, {
        "p-l-6": !props.className?.includes('p-l') && !hasHPad,
        "p-r-6": !props.className?.includes('p-r') && !hasHPad,
    })

    return (
        <ControlButtonStandard
            className       = {classes}
            size            = {props.params?.size || ControlButtonSize.SIZE_28}
            selectedClass   = "hover-bg"
            isSelected      = {true}
            isDisabled      = {props.disabled}
            onClick         = {props.onClick}
        >
            {_.get(props.field.components, 'ValueIcon', false)}
            <div className={labelClass}>{props.field.placeholder}</div>
            {props.children}

            {props.params?.showArrow &&
                <div className={arrowClass}/>}
        </ControlButtonStandard>
    )

}
